module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-3-f651f0181b61d0ca6301ff5d69264b33.png";